import { H3 } from "../../components/headline/Headline";

export default function ContactFormCompleted() {

    return <>
        <H3 text="Vielen Dank für Deine Anfrage" />
        <div>
            <p>
                Wir prüfen Deine Anfrage und kommen in Kürze auf Dich zu.<br />
                Solltest Du keine E-Mail erhalten oder weitere Fragen haben, dann melde dich gern unter <a href="mailto:moinmoin@cablesport.de">moinmoin@cablesport.de</a>
                <br />
                <br />
                Dein CAP Team
            </p>

        </div>
    </>
}  